<template>
    <div class="col-sm-12">
        <div class="card">
            <div class="card-body">
                <div class="form theme-form">
                    <!-- Tender Name -->
                    <div class="row">
                        <div class="col">
                            <div class="mb-3">
                                <label for="tender_name">Tender Name <span class="text-danger">*</span></label>
                                <input
                                    id="tender_name"
                                    v-model="tender_name"
                                    type="text"
                                    class="form-control input-air-primary"
                                    placeholder="Enter tender name"
                                    required
                                    :class="{'is-invalid': errors.tender_name}"
                                />
                            </div>
                        </div>
                    </div>

                    <!-- Closing Date -->
                    <div class="row">
                        <div class="col">
                            <div class="mb-3">
                                <label for="closing_date">Closing Date <span class="text-danger">*</span></label>
                                <input
                                    id="closing_date"
                                    v-model="closing_date"
                                    type="date"
                                    class="form-control input-air-primary"
                                    required
                                    :class="{'is-invalid': errors.closing_date}"
                                />
                            </div>
                        </div>
                    </div>

                    <!-- GC Company (SelectBox) -->
                    <div class="row">
                        <div class="col">
                            <SelectBox
                                label="GC Company"
                                selectId="gc_company_id"
                                :items="companies"
                                :itemKey="company => company.id"
                                :itemValue="company => company.id"
                                :itemLabel="company => company.company_name"
                                v-model:selectedValue="gc_company_id"
                                :wrapperClass="'mb-3'"
                                :placeholder="'Select a company'"
                                :class="{'is-invalid': errors.gc_company_id}"
                            />
                        </div>
                    </div>

                    <!-- File Manager -->
                    <div class="row" v-if="isEdit">
                        <div class="col">
                            <FileManager :tender-id="tender.id" :is-edit="isEdit" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
// Импортируем компонент SelectBox и FileManager
import SelectBox from "../Basic/Forms/SelectBox.vue";
import FileManager from "./FileManager.vue";
import axios from "axios";

export default {
    components: {
        SelectBox, // Компонент SelectBox
        FileManager, // Компонент для работы с файлами
    },
    props: {
        isEdit: {
            type: Boolean,
            default: false,
        },
        tender: {
            type: Object,
            default: () => ({}), // Пустой объект по умолчанию
        },
    },
    data() {
        return {
            tender_name: this.tender?.tender_name || '',
            closing_date: this.tender?.closing_date || '',
            gc_company_id: this.tender?.gc_company_id || '',
            companies: [],
            errors: {},
        };
    },
    methods: {
        fetchCompanies() {
            axios
                .get('/companies/list/get')
                .then((response) => {
                    this.companies = response.data.items;
                })
                .catch(() => {
                    this.companies = [];
                });
        },
        store() {
            const url = this.isEdit
                ? `/api/tenders/${this.tender.id}`
                : '/api/tenders';

            const method = this.isEdit ? 'put' : 'post';

            const payload = {
                tender_name: this.tender_name,
                closing_date: this.closing_date,
                gc_company_id: this.gc_company_id,
            };

            axios[method](url, payload)
                .then(() => {
                    this.$emit('stored');
                })
                .catch((error) => {
                    if (error.response && error.response.data) {
                        this.errors = error.response.data.errors || {};
                    }
                });
        },
    },
    watch: {
        tender: {
            immediate: true,
            handler(newTender) {
                this.tender_name = newTender.tender_name || '';
                this.closing_date = newTender.closing_date || '';
                this.gc_company_id = newTender.gc_company_id || '';
            },
        },
    },
    mounted() {
        this.fetchCompanies();
    },
};
</script>
